"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PerformanceManagementService = function () {
  function PerformanceManagementService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, PerformanceManagementService);
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(PerformanceManagementService, [{
    key: "addMonthlyDistribution",
    value: function addMonthlyDistribution(monthlyDistribution) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/addmonthlydistribution/", monthlyDistribution);
    }
  }, {
    key: "listMonthlyDistribution",
    value: function listMonthlyDistribution(entityId, year) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/listmonthlydistribution/" + entityId + "/" + year));
    }
  }, {
    key: "editMonthlyDistribution",
    value: function editMonthlyDistribution(monthlyDistribution) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/editmonthlydistribution/", monthlyDistribution);
    }
  }, {
    key: "removeMonthlyDistribution",
    value: function removeMonthlyDistribution(entityId, monthlyDistributionId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/removemonthlydistribution/" + entityId + "/" + monthlyDistributionId));
    }
  }, {
    key: "addUserTarget",
    value: function addUserTarget(userTarget) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/addusertarget/", userTarget);
    }
  }, {
    key: "listUserTargets",
    value: function listUserTargets(entityId, year) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/listusertargets/" + entityId + "/" + year));
    }
  }, {
    key: "editUserTarget",
    value: function editUserTarget(userTarget) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/editusertarget/", userTarget);
    }
  }, {
    key: "removeUserTarget",
    value: function removeUserTarget(entityId, userTargetId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/removeusertarget/" + entityId + "/" + userTargetId));
    }
  }, {
    key: "getTargetsOverview",
    value: function getTargetsOverview(criteria) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/getTargetsOverview", criteria);
    }
  }]);
  return PerformanceManagementService;
}();

exports.default = PerformanceManagementService;


// WEBPACK FOOTER //
// ./client/app/common/services/performanceManagementService.js